import { render } from "./base-skeleton-loader.vue?vue&type=template&id=ae8fef72&ts=true"
import script from "./base-skeleton-loader.vue?vue&type=script&lang=ts"
export * from "./base-skeleton-loader.vue?vue&type=script&lang=ts"

import "./base-skeleton-loader.vue?vue&type=style&index=0&id=ae8fef72&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__